// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.uppercase[data-v-3ab7d4ae] {\n  text-transform: uppercase;\n}\ninput.uppercase[data-v-3ab7d4ae]::-webkit-input-placeholder {\n  text-transform: none;\n}\ninput.uppercase[data-v-3ab7d4ae]::-moz-placeholder {\n  text-transform: none;\n}\ninput.uppercase[data-v-3ab7d4ae]:-moz-placeholder {\n  text-transform: none;\n}\ninput.uppercase[data-v-3ab7d4ae]:-ms-input-placeholder {\n  text-transform: none;\n}", ""]);
// Exports
module.exports = exports;
